import { cn } from "@/lib/cn";

/**
 * The ATHKYA wordmark.
 *
 * BRAND RULE — the supplied mark is light/white and is reproduced here exactly
 * as delivered. It is never recreated as vector, never recoloured, never
 * stretched, and never placed on a light background.
 *
 * Where a surface is not already dark, pass `plate` to sit the mark on an
 * approved dark plate rather than altering the artwork.
 */

const SIZES = {
  sm: "h-5",
  md: "h-6",
  lg: "h-8",
} as const;

export function Logo({
  size = "md",
  plate = false,
  alt = "ATHKYA",
  className,
}: {
  size?: keyof typeof SIZES;
  plate?: boolean;
  alt?: string;
  className?: string;
}) {
  const mark = (
    <img
      src="/brand/athkya-logo-light.png"
      alt={alt}
      width={401}
      height={102}
      decoding="async"
      className={cn("w-auto select-none", SIZES[size], !plate && className)}
      draggable={false}
    />
  );

  if (!plate) return mark;

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-xl bg-ink-950 px-3 py-2",
        "ring-1 ring-white/10",
        className,
      )}
    >
      {mark}
    </span>
  );
}
